import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, MessageCircle } from "lucide-react";
import { Logo } from "./Logo";
import { COMPANY, NAV_LINKS } from "../lib/constants";

export const Footer = () => (
  <footer className="bg-[var(--m-ink)] text-[var(--m-bg)]" data-testid="site-footer">
    <div className="container-x py-20">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <Logo inverse />
          <p className="mt-6 text-sm leading-relaxed text-white/70 max-w-md">
            An engineer-led, government-trusted construction firm delivering residential, commercial,
            interiors, PEB and approval-grade drawings — across Bengaluru.
          </p>
          <div className="gold-divider mt-6" />
          <p className="mt-6 text-xs uppercase tracking-[0.22em] text-[var(--m-gold-2)]">
            Led by Mr. Kiran K, C.Eng (Civil)
          </p>
          <p className="mt-1 text-xs text-white/60">Registered BBMP Engineer • Govt. of Karnataka</p>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.22em] text-white/50 mb-5">Navigate</div>
          <ul className="flex flex-col gap-3">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="text-sm text-white/85 hover:text-[var(--m-gold)] transition-colors"
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-xs uppercase tracking-[0.22em] text-white/50 mb-5">Reach Us</div>
          <ul className="flex flex-col gap-4 text-sm text-white/85">
            <li className="flex gap-3">
              <Phone size={16} className="mt-0.5 text-[var(--m-gold)]" strokeWidth={1.5} />
              <a href={`tel:${COMPANY.phoneRaw}`} className="hover:text-[var(--m-gold)]" data-testid="footer-phone">
                {COMPANY.phone}
              </a>
            </li>
            <li className="flex gap-3">
              <MessageCircle size={16} className="mt-0.5 text-[var(--m-gold)]" strokeWidth={1.5} />
              <a
                href={`https://wa.me/${COMPANY.whatsapp}`}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[var(--m-gold)]"
                data-testid="footer-whatsapp"
              >
                WhatsApp Chat
              </a>
            </li>
            <li className="flex gap-3">
              <Mail size={16} className="mt-0.5 text-[var(--m-gold)]" strokeWidth={1.5} />
              <a href={`mailto:${COMPANY.email}`} className="hover:text-[var(--m-gold)]" data-testid="footer-email">
                {COMPANY.email}
              </a>
            </li>
            <li className="flex gap-3">
              <MapPin size={16} className="mt-0.5 text-[var(--m-gold)] flex-shrink-0" strokeWidth={1.5} />
              <span className="leading-relaxed">{COMPANY.address}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4">
        <p className="text-xs text-white/50">
          © {new Date().getFullYear()} Agartha Construction. All rights reserved.
        </p>
        <p className="text-xs text-white/50">
          Engineering-led • BBMP Compliant • Govt. of Karnataka Experience
        </p>
      </div>
    </div>
  </footer>
);
